import { CampaignName } from '../types';
import { Locale } from '../types';

export enum GrowthbookExperimentID {
  GROWTHBOOK_SHOW_MONTHLY_PLANS_DEFAULT = 'show-monthly-plans-default',
  GROWTHBOOK_NEW_HOME_PAGE_DESIGN = 'new-home-page-design',
  GROWTHBOOK_INCREASED_PRICES_CAMPAIGN = 'increased-prices-campaign',
  GROWTHBOOK_HIDE_OTHER_APPS = 'hide-other-apps',
  GROWTHBOOK_CHANGE_BUTTONS_TEXT_COLOR = 'change-buttons-text-color',
}

export enum GrowthbookFeatureFlagID {
  GROWTHBOOK_SHOW_BOOTCAMP_SE = 'show-bootcamp-se',
}

export enum AbTestsMixpanelKey {
  WEB_SHOW_MONTHLY_PLANS_DEFAULT_SE = 'web_show_monthly_plans_default_se_140125',
  WEB_NEW_HOME_PAGE_DESIGN_PL = 'web_new_home_page_design_pl_120625',
  WEB_INCREASED_PRICES_CAMPAIGN_CZ = 'web_increased_prices_campaign_cz_120625',
  WEB_HIDE_OTHER_APPS_SE = 'web_plan_cards_hide_other_apps_se_140725',
  WEB_CHANGE_BUTTONS_TEXT_COLOR_DK = 'web_change_buttons_text_color_dk_150725',
}

export type AbTest = Partial<Record<Locale, { mixpanelId: AbTestsMixpanelKey; campaignName?: CampaignName }>>;

export type AbTestsData = Record<AbTestsMixpanelKey, number>;

export const AB_TESTS: Record<GrowthbookExperimentID, AbTest> = {
  [GrowthbookExperimentID.GROWTHBOOK_SHOW_MONTHLY_PLANS_DEFAULT]: {
    [Locale.SE]: {
      mixpanelId: AbTestsMixpanelKey.WEB_SHOW_MONTHLY_PLANS_DEFAULT_SE,
    },
  },
  [GrowthbookExperimentID.GROWTHBOOK_NEW_HOME_PAGE_DESIGN]: {
    [Locale.PL]: {
      mixpanelId: AbTestsMixpanelKey.WEB_NEW_HOME_PAGE_DESIGN_PL,
    },
  },
  [GrowthbookExperimentID.GROWTHBOOK_INCREASED_PRICES_CAMPAIGN]: {
    [Locale.CZ]: {
      mixpanelId: AbTestsMixpanelKey.WEB_INCREASED_PRICES_CAMPAIGN_CZ,
      campaignName: CampaignName.SchoolStartCz7,
    },
  },
  [GrowthbookExperimentID.GROWTHBOOK_HIDE_OTHER_APPS]: {
    [Locale.SE]: {
      mixpanelId: AbTestsMixpanelKey.WEB_HIDE_OTHER_APPS_SE,
    },
  },
  [GrowthbookExperimentID.GROWTHBOOK_CHANGE_BUTTONS_TEXT_COLOR]: {
    [Locale.DK]: {
      mixpanelId: AbTestsMixpanelKey.WEB_CHANGE_BUTTONS_TEXT_COLOR_DK,
    },
  },
};
